module.exports = "<mat-card>\n  <img mat-card-image alt=\"page under construction\" style=\"\" src=\"assets/images/site-under-construction.jpg\">\n</mat-card>"